import React from 'react';
import { X } from 'lucide-react';

interface DeleteAccountModalProps {
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
}

const DeleteAccountModal: React.FC<DeleteAccountModalProps> = ({ onClose, onConfirm, isDeleting }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-surface rounded-lg max-w-md w-full overflow-hidden shadow-xl">
        <div className="px-6 pt-4 pb-2">
          <div className="flex justify-between items-center mb-4">
            <h3 className="font-display font-normal tracking-tight text-xl text-ink-900">Delete Account</h3>
            <button 
              onClick={onClose}
              className="text-ink-400 hover:text-ink-600 transition-colors"
              disabled={isDeleting}
            >
              <X className="w-6 h-6" />
            </button>
          </div>
          
          <div className="mb-6">
            <p className="text-ink-600 mb-4">
              Are you sure you want to delete your account? This action cannot be undone and will:
            </p>
            <ul className="list-disc pl-5 text-ink-600 space-y-2">
              <li>Permanently delete your account</li>
              <li>Remove all your venue visit history</li>
              <li>Delete all your personal data</li>
            </ul>
          </div>
        </div>
        
        <div className="px-6 py-4 bg-ink-50 flex justify-end space-x-3">
          <button
            onClick={onClose}
            disabled={isDeleting}
            className="px-4 py-2 text-sm font-medium text-ink-700 bg-surface border border-ink-300 rounded-md hover:bg-ink-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isDeleting}
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50 flex items-center"
          >
            {isDeleting ? (
              <>
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Deleting...
              </>
            ) : (
              'Delete Account'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountModal;